export const getGreeting = () => {
  const hour = new Date().getHours();

  if (hour >= 6 && hour < 12) {
    return { text: "Good Morning", emoji: "☀️" };
  }
  if (hour >= 12 && hour < 17) {
    return { text: "Good Afternoon", emoji: "🌤️" };
  }
  if (hour >= 17 && hour < 21) {
    return { text: "Good Evening", emoji: "🌇" };
  }
  return { text: "Good Night", emoji: "🌙" };
};

export const formatLastLogin = (dateString) => {
  if (!dateString) return null;
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return null;

  const formattedDate = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const formattedTime = date.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });

  return `${formattedDate} • ${formattedTime}`;
};
